module.exports = __webpack_public_path__ + "img/04.e9387f59.png";